import { List } from 'immutable';

import { ActionTypes, keyGoPaymentCardStatus } from '../constants/AppConstants';
import ModalActions from '../actions/ModalActions';

import BaseStore from './BaseStore';
import UserStore from './UserStore';
import SmartcardStore from './SmartcardStore';
import FeatureFlagStore from './FeatureFlagStore';
import BrandSplitModal from '../components/general/BrandSplitModal';
import KeyGoIncompleteJourneyModal from '../components/account/smartcard/KeyGoIncompleteJourneyModal';
import PromptModal from '../components/customer/marketingPrefs/PromptModal';
import KeyGoCardExpireModal from '../components/account/smartcard/keyGo/KeyGoCardExpireModal';

export class NotificationCentreStore extends BaseStore {

    getInitialState () {
        return this.calculateNotifications();
    }

    calculateNotifications () {
        const user = UserStore.getCurrent();
        const smartcard = SmartcardStore.getCurrent();
        const keyGo = smartcard && smartcard.getKeyGo();
        const showBrandSplitModal = FeatureFlagStore.get('showBrandSplitModal');
        const enableKeyGoSelfCompleteJourneys = FeatureFlagStore.get('enableKeyGoSelfCompleteJourneys');
        const enableKeyGoPaymentCardExpiryReminder = FeatureFlagStore.get('enableKeyGoPaymentCardExpiryReminder');
        const notifications = new List([
            {
                title: 'brand.split.header',
                description: 'notifications.brandSplit.description',
                shouldShow: () => {
                    return user && user.customer && !user.brandChosen && showBrandSplitModal;
                },
                onClick: () => {
                    ModalActions.open(BrandSplitModal);
                }
            },
            {
                title: 'notifications.keyGoIncompleteJourney.text',
                description: 'account.heading.smartcard.keygo.incompletejourneys',
                shouldShow: () => {
                    if (user && user.smartcardRegistered) {
                        if (enableKeyGoSelfCompleteJourneys && keyGo && keyGo.hasIncompleteJourneys()) {
                            return true;
                        }
                    }
                    return false;
                },
                onClick: () => {
                    ModalActions.open(KeyGoIncompleteJourneyModal);
                }
            },
            {
                title: 'preference-centre.notification.title',
                description: 'preference-centre.notification.description',
                shouldShow: () => {
                    if (user.preferences && user.preferences.get('timestamp')) {
                        return false;
                    }
                    return true;
                },
                onClick: () => {
                    ModalActions.open(PromptModal);
                }
            },
            {
                title: 'notifications.keyGoCardExpire.title',
                description: 'notifications.keyGoCardExpire.description',
                shouldShow: () => {
                    return user && user.smartcardRegistered && enableKeyGoPaymentCardExpiryReminder && keyGo && keyGo.isPaymentCardExpiredOrAboutTo();
                },
                onClick: () => {
                    ModalActions.open(KeyGoCardExpireModal,
                        { cardStatus: keyGo ? keyGo.getPaymentCardStatus() : keyGoPaymentCardStatus.NO_CARD }
                    );
                }
            },
        ]);
        return notifications.filter(notification => notification.shouldShow());
    }

    updateNotifications () {
        this.setState(this.calculateNotifications());
    }

    getNotifications () {
        return this.state;
    }

    getActionHandlers () {
        return {
            [ ActionTypes.AUTH_LOADED ]: this.updateNotifications,
            [ ActionTypes.USER_UPDATED ]: this.updateNotifications,
            [ ActionTypes.AUTH_REFRESHED ]: this.updateNotifications,
            [ ActionTypes.LOGGED_IN ]: this.updateNotifications,
            [ ActionTypes.LOGGED_OUT ]: this.updateNotifications,
            [ ActionTypes.REGISTRATION_SUCCESS ]: this.updateNotifications,
            [ ActionTypes.SMARTCARD_LOADED ]: this.updateNotifications,
            [ ActionTypes.USER_PREFERENCES_UPDATED ]: this.updateNotifications
        };
    }
}

const instance = new NotificationCentreStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/NotificationCentreStore.js